import { Badge as BadgeAntd, BadgeProps } from 'antd';
import classNames from 'classnames';
import { memo } from 'react';

export const Badge = memo(({ className, ...rest }: BadgeProps) => (
  <BadgeAntd className={classNames(className)} {...rest} />
));

Badge.displayName = 'Badge';
